export default __webpack_public_path__ + "static/media/ws.8ef2c295.svg";